import { AbstractControl } from '@angular/forms';

export function BudgetMaxStodnivaRequired(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const noMissingMaxStodniva = !parsedValue.projektparter.some(
      (p) =>
        p.bidragPerAr.some((bidrag) => bidrag.summa > 0) &&
        (p.maxStodniva?.varde == undefined || p.maxStodniva?.varde === ''),
    );
    if (noMissingMaxStodniva) {
      return;
    }
  }

  return { MaxStodnivaRequired: true };
}
